import { render, staticRenderFns } from "./group-timetable-area.vue?vue&type=template&id=1bce70ba&scoped=true&lang=pug&"
import script from "./group-timetable-area.vue?vue&type=script&lang=js&"
export * from "./group-timetable-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce70ba",
  null
  
)

export default component.exports